import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useThemeColors } from "../Context/Theme";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

function GlobalButton({
  onClick,
  bgcolor,
  text,
  color,
  borderColor,
  className,
  size,
  block,
  startIcon,
  padding,
  height,
  width,
  margin,
  border,
}) {
  // Responsive breakpoints
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width:960px)");
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontWeight, fontSize, fontFamily 
  } = useThemeColors();
  const buttonStyle = {
    backgroundColor: bgcolor || buttonColor,
    color: color || buttonTextColor,
    borderColor: borderColor || "transparent",
    border: border || "none",
    width: block ? "90%" : width || (isSmallScreen ? "80%" : "auto"),
    display: "flex",
    alignItems: "center",
    justifyContent: startIcon ? "center" : "center",
    padding: padding || (isSmallScreen ? "8px 12px" : "10px 20px"),
    borderRadius: "8px",
    fontSize: isSmallScreen ? (fontSize || "10px") : isMediumScreen ?(fontSize || "11px") : (fontSize || "11px"),
    height: height || (isSmallScreen ? "40px" : "auto"),
    marginRight: margin || (isSmallScreen ? "0" : "12vw"),
    marginBottom: isSmallScreen ? "10px" : "0",
    cursor: "pointer",
    fontWeight: fontWeight || "500",
    fontFamily
  };

  return (
    <button
      type="button"
      className={`btn btn-lg ${size ? `btn-${size}` : ""} ${
        block ? "w-100" : ""
      }  ${className}`}
      style={buttonStyle}
      onClick={onClick}
    >
      {startIcon && (
        <ShoppingCartIcon fontSize="small" />  
      )}
      <span style={{ fontSize: (fontSize || "1.2em"), fontWeight: (fontWeight || "600"), fontFamily }}>{text}</span>
    </button>
  );
}

export default GlobalButton;
